export default __webpack_public_path__ + "static/media/ministry-inactive.41f29329.svg";